import { initFancyBox, countUp, ImportBundle, lazyLoad, fixedsHeader, initToTop, globalSearch, initSearch, handleSendInquiry, filpHeight } from "./common";
import sideBar1_Init from "@common/components/sideBar-1";
import dialogFormInit from "./components/dialogForm-1";


import _productDetail02 from "./page/productDetail-2"

import _contactUs04 from "./page/contactUs-4"

common();


_productDetail02();

_contactUs04();

function common() {
  countUp();
  initFancyBox();
  lazyLoad();
  fixedsHeader("page__header");
  initSearch(".header-search form", ".header-search .toggle");
  globalSearch();
  initSearch();
  sideBar1_Init();
  initEvent();
  ImportBundle({ type: "js" }, [
    {
      src: "https://static.addtoany.com/menu/page.js",
      async: true,
      fn: () => {
        let a2a_config = window.a2a_config || {};
        a2a_config.onclick = 1;
        window.a2a_config = a2a_config;
      },
    },
    {
      src: "https://static.yigetechcms.com/public/js/bootstrap@4.6.2.min.js",
    },
  ]);
  ImportBundle({ type: "css" }, ["https://static.yigetechcms.com/public/css/swiper-bundle@11.1.1.min.css", "https://static.yigetechcms.com/public/css/bootstrap@4.6.2.min.css"]);

}

function initEvent() {
  dialogFormInit();
  handleSendInquiry({ formId: "#Inquiry-form", trigger: "#Inquiry-submit" });
  handleSendInquiry({ formId: "#footer-1-form", trigger: "#footer-1-submit" });
  filpHeight(".productList-1 .productList-1_SEO .showBtn", ".productList-1 .productList-1_SEO article", 3);
  $(".productDetail-2 .productDetail-2_detail table").addClass("table table-bordered table-striped")
  if (window.screen.width <= 1024) {
    $("table").wrap('<div class="table-responsive"></div>');
  }

}